<template>
  <div class='PedidoView'>
    <div class="numero-status">
      <div>Pedido #{{ PedidoView.id }}</div>
      <div class="status">{{ PedidoView.status }}</div>
    </div>
    <div class="cont-status">
      <update-status-pedido
      :data="PedidoView"
      />
      <div class="cont-detalhes-pagamento">
        <button class="detalhes-pagamento" @click="SetModal({ active: true, component: 'PaymentInfo' })">Detalhes do pagamento</button>
      </div>
    </div>
    <div class="title">
      Informações do cliente
    </div>
    <div class="block">
      <input-reg
      disabled
      :value="PedidoView.usuario.usuario"
      text="Usuário"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
      <input-reg
      disabled
      :value="PedidoView.usuario.email"
      text="Email"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
    </div>
    <div class="block">
      <input-reg
      disabled
      :value="PedidoView.usuario.nome"
      text="Primeiro nome"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
      <input-reg
      disabled
      :value="PedidoView.usuario.sobrenome"
      text="Sobrenome"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
    </div>
    <div class="block">
      <input-reg
      disabled
      :value="PedidoView.endereco.cpf"
      text="CPF"
      :cont="{ width: '30%', paddingLeft: '0.6%' }"
      :label="{ textAlign: 'left', marginLeft: '1%' }"
      :input="{ fontSize: '20px', padding: '2.4%', width: '94%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
      <input-reg
      disabled
      :value="PedidoView.endereco.celular"
      text="Celular"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '3%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '92%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
      <input-reg
      disabled
      :value="PedidoView.endereco.cep"
      text="CEP"
      :cont="{ width: '18.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '4%', width: '92%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
    </div>
    <div class="block">
      <input-reg
      disabled
      :value="PedidoView.endereco.bairro"
      text="Bairro"
      :cont="{ width: '30%', paddingLeft: '0.6%' }"
      :label="{ textAlign: 'left', marginLeft: '1%' }"
      :input="{ fontSize: '20px', padding: '2.4%', width: '94%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
      <input-reg
      disabled
      :value="PedidoView.endereco.endereco"
      text="Endereço"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '3%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '92%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
      <input-reg
      disabled
      :value="PedidoView.endereco.numero"
      text="Número"
      :cont="{ width: '18.5%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '4%', width: '92%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
    </div>
    <div class="block">
      <input-reg
      disabled
      :value="PedidoView.endereco.cidade"
      text="Cidade"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
      <input-reg
      disabled
      :value="PedidoView.endereco.uf"
      text="Estado(UF)"
      :cont="{ width: '50%' }"
      :label="{ textAlign: 'left', marginLeft: '2%' }"
      :input="{ fontSize: '20px', padding: '1.5%', width: '94%', border: 'thin solid #CCCCCC', borderRadius: '5px' }"
      />
    </div>
    <div class="title">
      Informações adicionais
    </div>
    <div class="notas-pedido">
      {{ PedidoView.notas }}
    </div>
    <div class="title">
      Itens do pedido
    </div>
    <pedido-header-view/>
    <pedido-item-view
    v-for="(i, k) in PedidoView.itens"
    :key="k"
    :data="i"
    />
    <div class="values">
      <div class="desc">Código Cupom:</div>
      <div class="valor">{{ PedidoView.gift }}</div>
    </div>
    <div class="values">
      <div class="desc">Desconto:</div>
      <div class="valor">{{ PedidoView.giftvalor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <div class="values">
      <div class="desc">Frete:</div>
      <div class="valor">{{ PedidoView.frete.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <div class="values bold">
      <div class="desc">Total do pedido:</div>
      <div class="valor">{{ ((total + PedidoView.frete) - PedidoView.giftvalor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InputReg from '../Produtos/Register/InputReg'
import PedidoHeaderView from './Itens/PedidoHeaderView'
import PedidoItemView from './Itens/PedidoItemView'
import UpdateStatusPedido from './UpdateStatusPedido'
export default {
  name: 'PedidoView',
  components: { InputReg, PedidoHeaderView, PedidoItemView, UpdateStatusPedido },
  computed: {
    ...mapGetters(['PedidoView']),
    total () {
      return this.PedidoView.itens.map(i => i.preco * i.qtda).reduce((p, c) => c + p, 0)
    }
  },
  methods: {
    ...mapActions(['SetModal'])
  }
}
</script>

<style scoped>
.PedidoView {
  width: 100%;
  height: 84%;
  padding-bottom: 7%;
  overflow: auto;
}

.numero-status {
  display: flex;
  align-items: center;
  padding: 1.5%;
  font-size: 20px;
  color: #a50201;
}

.cont-status {
  display: flex;
}

.cont-detalhes-pagamento {
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.detalhes-pagamento {
  border: thin solid #2964a7;
  padding: 2%;
  border-radius: 5px;
  font-size: 16px;
  color: #2964a7;
  background-color: #FFFFFF;
  cursor: pointer;
}

.status {
  background-color: #20c997;
  color: #FFFFFF;
  font-size: 16px;
  padding: 0.4%;
  border-radius: 5px;
  margin-left: 1%;
}

.title {
  text-align: left;
  padding: 1.5%;
  font-size: 20px;
  font-weight: bold;
}

.notas-pedido {
  text-align: left;
  padding: 1.5%;
}

.block {
  display: flex;
  padding: 0.5%;
}

.values {
  display: flex;
  justify-content: end;
  padding: 1%;
}

.desc {
  width: 15%;
  text-align: right;
}

.valor {
  width: 15%;
}

.bold {
  font-size: 18px;
  font-weight: bold;
}

@media (max-width: 500px) {
  .PedidoView {
    height: 70%;
  }
  .desc {
    width: 30%;
  }
  .valor {
    width: 20%;
  }
}
</style>
